import React from 'react'
import { Desc } from '../../../../../../Components/Typography/Text.styles'
import { colors } from '../../../../../../Components/consts'
import { returnASGCoach } from '../../../../consts'

type CoachParams = {
  side: 'left' | 'right'
}

export const Coach: React.FC<React.PropsWithChildren<CoachParams>> = ({ side }) => {
  return (
    <>
      {side === 'left' && (
        <>
          {/* <Desc  color={colors.gray.gray40}>{'Coaches will be announced later.'}</Desc> */}
          <Desc textColor={colors.gray.gray40}>{returnASGCoach('away', 'head')}</Desc>
          <Desc textColor={colors.gray.gray40}>{returnASGCoach('away', 'assistant')}</Desc>
        </>
      )}
      {side === 'right' && (
        <>
          {/* <Desc  color={colors.gray.gray40}>{'Coaches will be announced later.'}</Desc> */}
          <Desc textColor={colors.gray.gray40}>{returnASGCoach('home', 'head')}</Desc>
          <Desc textColor={colors.gray.gray40}>{returnASGCoach('home', 'assistant')}</Desc>
        </>
      )}
    </>
  )
}
